'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmbedHtml = require('./EmbedHtml');

var _EmbedHtml2 = _interopRequireDefault(_EmbedHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmbedHtml2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-embed-content/lib/cjs/EmbedHtml/index.js
 ** module id = 504
 ** module chunks = 1
 **/